import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import { Route } from 'react-router'
import styled from 'styled-components'

import SectionHandler from 'components/SectionHandler'
import sectionsArr from './sections'

const StyledRow = styled(Row)`
	${/* Overrides 'react-flexbox-grid' css */''}
	div& {
		flex-grow: 1;
	}
`


const OptionsHandler = props => {
	const [t] = useTranslation()
	const { sectionData, appData } = props
	const optionsSectionsRegexp = []
	const sections = sectionsArr.map(item => {
		let out = item
		if(typeof item === 'function') {
			out = item(t, props)
		}
		optionsSectionsRegexp.push(out?.link)
		return out
	})

	return(
		<StyledRow>
			<Col xs={12}>
				<Route path={`/${sectionData.link}/:section(${optionsSectionsRegexp.join('|')})?/:subsection?/:id?`} render={routerProps => (
					<SectionHandler
						{...routerProps}
						sections={sections}
						baseUrl={sectionData.link}
						sectionPathRedirect={false}
						appData={appData}
						replaceOnlyIdOnRoute={true}
					/>
				)}/>
			</Col>
		</StyledRow>
	)
}

export default OptionsHandler
